import { Switch } from '@/shared/components/ui/switch';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/shared/components/ui/table';

export type ParticipationListItem = {
  user: string;
  userId: string;
  itemCount: number;
  collected: boolean;
};

type ParticipationListProp = {
  items: ParticipationListItem[];
  onRowClick: (userId: string) => void;
  showCollected?: boolean;
  onCollectedChange?: (userId: string, collected: boolean) => void;
};

export function ParticipationList({ items, onRowClick, showCollected, onCollectedChange }: ParticipationListProp) {
  return (
    <Table className="table-fixed">
      <TableHeader>
        <TableRow className="hover:bg-transparent [&>*:last-child]:text-right md:[&>*:last-child]:text-left">
          <TableHead className="w-1/2 md:w-auto">Namn</TableHead>
          <TableHead className="w-1/4 md:w-auto">Produkter</TableHead>
          {showCollected && <TableHead className="w-1/4 md:w-auto">Hämtat</TableHead>}
        </TableRow>
      </TableHeader>
      <TableBody>
        {items.length > 0 ? (
          items.map((item) => (
            <TableRow
              key={item.userId}
              className="hover:cursor-pointer [&>*:last-child]:text-right md:[&>*:last-child]:text-left"
              onClick={(e) => {
                e.stopPropagation();
                e.nativeEvent.stopImmediatePropagation();
                onRowClick(item.userId);
              }}
            >
              <TableCell className="font-medium w-1/2 md:w-auto">{item.user}</TableCell>
              <TableCell className="w-1/4 md:w-auto">{item.itemCount} st</TableCell>
              {showCollected && (
                <TableCell className="font-medium w-1/4 md:w-auto">
                  <Switch
                    onClick={(e) => e.stopPropagation()}
                    checked={item.collected}
                    onCheckedChange={(collected) => onCollectedChange?.(item.userId, collected)}
                  />
                </TableCell>
              )}
            </TableRow>
          ))
        ) : (
          <TableRow>
            <TableCell colSpan={showCollected ? 3 : 2} className="text-center py-6">
              Inga säljare hittades
            </TableCell>
          </TableRow>
        )}
      </TableBody>
    </Table>
  );
}
